import { useState } from "react";
import styles from "./VLQPage.module.css";
import Button from "../../components/common/Button";

const DOMAINS = [
  "Família",
  "Relacionamentos íntimos",
  "Amizades",
  "Trabalho / carreira",
  "Educação / desenvolvimento pessoal",
  "Lazer",
  "Espiritualidade / sentido de vida",
  "Saúde física",
  "Cuidado consigo",
  "Comunidade / contribuição social",
];

export default function VLQPage() {
  const [responses, setResponses] = useState(
    DOMAINS.map(() => ({ importance: null, action: null }))
  );
  const [submitted, setSubmitted] = useState(false);

  const updateValue = (index, field, value) => {
    const updated = [...responses];
    updated[index] = { ...updated[index], [field]: value };
    setResponses(updated);
  };

  const allAnswered = responses.every(
    (r) => r.importance !== null && r.action !== null
  );

  const discrepancies = responses.map((r) => r.importance - r.action);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>VLQ – Valores e Ação</h1>
        <p>
          Esta escala convida à reflexão sobre o que é importante em diferentes
          áreas da vida e o quanto as ações recentes têm sido consistentes com
          esses valores. Não há respostas certas ou erradas.
        </p>
      </header>

      {!submitted && (
        <form className={styles.form}>
          {DOMAINS.map((domain, index) => (
            <div key={domain} className={styles.domain}>
              <h3 className={styles.domainTitle}>{domain}</h3>

              <div className={styles.row}>
                <label className={styles.label}>
                  Importância
                  <select
                    value={responses[index].importance ?? ""}
                    onChange={(e) =>
                      updateValue(index, "importance", Number(e.target.value))
                    }
                  >
                    <option value="">–</option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </label>

                <label className={styles.label}>
                  Ação consistente
                  <select
                    value={responses[index].action ?? ""}
                    onChange={(e) =>
                      updateValue(index, "action", Number(e.target.value))
                    }
                  >
                    <option value="">–</option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          ))}

          <Button
            disabled={!allAnswered}
            onClick={(e) => {
              e.preventDefault();
              setSubmitted(true);
            }}
          >
            Ver resultado
          </Button>
        </form>
      )}

      {submitted && (
        <section className={styles.result}>
          <h2>Reflexão sobre valores e ação</h2>

          <p className={styles.interpretation}>
            A diferença entre importância e ação em cada área pode indicar
            espaços de maior alinhamento ou discrepância neste momento da vida.
            Discrepâncias maiores não são falhas, mas possíveis pontos de
            exploração clínica.
          </p>

          <ul className={styles.summary}>
            {DOMAINS.map((domain, i) => (
              <li key={domain}>
                <strong>{domain}:</strong> diferença de {discrepancies[i]}
              </li>
            ))}
          </ul>

          <p className={styles.note}>
            Estes resultados não definem prioridades nem indicam o que deve ser
            feito. Eles podem servir como ponto de partida para conversas sobre
            direção, escolhas e ação comprometida no processo terapêutico.
          </p>

          <Button onClick={() => setSubmitted(false)}>Refazer escala</Button>
        </section>
      )}
    </div>
  );
}
